import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router';
import { useTypedParams } from 'react-router-typesafe-routes';
import GroupAdminSelectList from '@/components/groups/group-admin-sectioned-list/group-admin-select-list';
import PageLayout from '@/components/layouts/page-layout/page-layout';
import useGroupInfo from '@/hooks/groups/use-group-info';
import ROUTES from '@/routes';

export default function AddGroupAdminRoute() {
  const { t } = useTranslation();
  const { id: groupId } = useTypedParams(ROUTES.MESSAGES.GROUPS);
  const { canManage, isLoading } = useGroupInfo(groupId);

  if (!isLoading && !canManage) {
    return (
      <Navigate
        replace
        to='..'
      />
    );
  }

  return (
    <PageLayout
      title={t('conversation.setting.group.admin.add-admin')}
      className='w-full pb-safe-offset-4'
      headerConfig={{
        navigateBack: true,
      }}>
      <GroupAdminSelectList groupId={groupId} />
    </PageLayout>
  );
}
